<template>
    <div class="mp-progress">
        <v-row @click.prevent="toggleExtended"
               v-if="name !== 'ihk_premium_seller' || name === 'ihk_premium_seller' && ihkCertificate">
            <v-col class="mp-progress__name body-1 d-flex align-center">
                <mp-bar :color="attributeColorMapping[name]"></mp-bar>
                <div class="ml-1">
                    {{ $vuetify.lang.t(`$vuetify.page_rang_detail.${name}`) }}
                </div>
            </v-col>
            <v-col cols="auto"
                   class="headline font-weight-bold d-flex align-center">
                {{ value }} {{ $vuetify.lang.t('$vuetify.points.master') }}
                <v-icon v-if="extended"
                        class="ml-auto">mdi-menu-up
                </v-icon>
                <v-icon v-else
                        class="ml-auto">mdi-menu-down
                </v-icon>
            </v-col>
            <template v-if="extended && name === 'sold_vehicles'">
                <v-col v-if="user.country_code === 'DE'"
                       cols="12"
                       class="mp-progress__content-container body-1 pt-0"
                       v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}.de.${currentYear}`)">
                </v-col>
                <v-col v-else
                       cols="12"
                       class="mp-progress__content-container body-1 pt-0"
                       v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}.exp.${currentYear}`)">
                </v-col>
            </template>
            <template v-if="extended && name === 'trainings'">
                <v-col v-if="user.country_code === 'DE'"
                       cols="12"
                       class="mp-progress__content-container body-1 pt-0"
                       v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}_de`)">
                </v-col>
                <v-col v-else
                       cols="12"
                       class="mp-progress__content-container body-1 pt-0"
                       v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}_exp`)">
                </v-col>
            </template>
            <template v-if="extended && name === 'trade_fairs'">
                <v-col v-if="countryCodes.includes(user.country_code)"
                       cols="12"
                       class="mp-progress__content-container body-1 pt-0"
                       v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}_${user.country_code.toLowerCase()}`)">
                </v-col>
                <!-- fallback = en -->
                <v-col v-else
                       cols="12"
                       class="mp-progress__content-container body-1 pt-0"
                       v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}_en`)">
                </v-col>
            </template>
            <v-col v-if="extended && !cats.includes(name)"
                   cols="12"
                   class="mp-progress__content-container body-1 pt-0"
                   v-html="$vuetify.lang.t(`$vuetify.page_rang_detail.info.${$options.filters.slugify(brand.name)}.${name}`)">
            </v-col>
        </v-row>
    </div>
</template>
<script>
import MpBar from './MpBar';

export default {
    name: 'mp-progress',
    components: {
        MpBar,
    },
    props: {
        user: {},
        brand: {},
        name: {},
        content: {},
        color: {},
        value: {},
        max: {},
        attributeColorMapping: {},
        ihkCertificate: {},
    },
    data() {
        return {
            cats: ['trainings', 'trade_fairs', 'sold_vehicles'],
            countryCodes: ['DE', 'AT', 'CH', 'BE', 'DK', 'ES', 'FR', 'IT', 'LU', 'NL'],
            extended: false,
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
    },
    methods: {
        toggleExtended() {
            this.extended = !this.extended;
        },
    },
};
</script>
